<div>
  <div class="card mt-4">
    <div class="card-body">
      <h5 class="card-title title_header_0">Step 1 - Upload Documents</h5>
      <form [formGroup]="productDetails">
        <div class="row">
          <div class="col-lg-3 col-sm-3 col-md-3 overlay_1">
            <span class="form_field"> Branch</span>
            <div class="custom-input">
              <input
                class="readOnly branch_background"
                type="text"
                pInputText
                readOnly="true"
                formControlName="branchName"
              />
            </div>
          </div>
          <div class="ms-2 col-lg-4 col-sm-4 col-md-4">
            <span class="form_field ms-4">Select Service</span>
            <span class="color_red">*</span>
            <!-- <span class="upload-text row mb-2" style="margin-left: 1.5rem; font-weight: 600;"><span class="color_red">*</span></span> -->
            <div class="flex_row ms-4 mt-1">
              <div class="flex_row p-field-radiobutton radio_btn">
                <input
                  type="radio"
                  id="downloadEsign"
                  name="documentType"
                  value="E-Sign"
                  [(ngModel)]="serviceType"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="excelOption($event)"
                />
                <label class="me-1 ms-1 font_size_12">E-Signing</label>
              </div>
              <div class="flex_row p-field-radiobutton radio_btn ms-3">
                <input
                  type="radio"
                  id="downloadEstamp"
                  name="documentType"
                  value="E-Stamp"
                  [(ngModel)]="serviceType"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="excelOption($event)"
                />
                <label class="me-1 ms-1 font_size_12">E-Stamping</label>
              </div>
              <div class="flex_row p-field-radiobutton radio_btn ms-3">
                <input
                  type="radio"
                  id="downloadBoth"
                  name="documentType"
                  value="Both"
                  [(ngModel)]="serviceType"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="excelOption($event)"
                />
                <label class="me-1 ms-1 font_size_12"
                  >Both(E-Signing & E-Stamping)</label
                >
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div
            *ngIf="showProcessTypeDropdown"
            class="col-lg-3 col-sm-3 col-md-3 overlay_1"
          >
            <span class="form_field">Process Type</span>
            <span class="color_red">*</span>
            <div style="display: block">
              <div>
                <app-dropdown
                  class="custom-dropdown"
                  [options]="processTypeOptions"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [sort]="false"
                  (onChange)="onStampProcessTypeChange($event)"
                  [(ngModel)]="selectedStampProcessType"
                  placeholder="Select Process Type"
                >
                </app-dropdown>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-3 col-md-3">
            <span class="form_field" style="display: block"
              >Upload the Filled Excel document
              <span class="color_red">*</span></span
            >
            <div class="d-flex align-items-center gap-2">
              <a
                style="font-size: 10px; color: #612e86"
                data-bs-toggle="modal"
                data-bs-target="#uploadDocModal"
                class="btn-link clickable upload-btn"
                ><app-button
                  label="Upload"
                  variant="primary"
                  size="md"
                  (clicked)="openUploadDocPopup()"
                >
                  <i class="upload_icon_color bx bx-upload bx-sm"></i>
                </app-button
              ></a>
              <app-button
                *ngIf="showFileName && (serviceType === 'E-Stamp' || serviceType === 'E-Sign' || serviceType === 'Both')"
                label="View"
                variant="primary"
                size="md"
                (clicked)="openViewPopUp(viewPopUp)"
              ></app-button>
            </div>

            <div *ngIf="showFileName" class="ms-2 mt-1">
              <span
                class="badge background_color_3 status_title_1"
                style="color: #151515; font-size: 0.5rem"
                >{{ fileName }}
                <i class="clickable ms-2 bx bx-x" (click)="removeFileName()"></i
              ></span>
            </div>
          </div>
        </div>
      </form>

      <div class="text-right">
        <a
          style="font-size: 10px; color: #612e86"
          [attr.data-bs-toggle]="
            ((isPrepaid &&
                (serviceType === 'Both' || serviceType === 'E-Sign')) ||
              (isPrepaid &&
                serviceType === 'E-Stamp' &&
                selectedStampProcessType === 'ON_THE_FLY') ||
              (isPostpaid &&
                (serviceType === 'E-Stamp' || serviceType === 'Both') &&
                selectedStampProcessType === 'ON_THE_FLY'))
              ? 'modal'
              : null
          "
          [attr.data-bs-target]="
            ((isPrepaid &&
                (serviceType === 'Both' || serviceType === 'E-Sign')) ||
              (isPrepaid &&
                serviceType === 'E-Stamp' &&
                selectedStampProcessType === 'ON_THE_FLY') ||
              (isPostpaid &&
                (serviceType === 'E-Stamp' || serviceType === 'Both') &&
                selectedStampProcessType === 'ON_THE_FLY'))
              ? '#uploadPlaceOrderModal'
              : null
          "
          class="btn-link clickable upload-btn"
          [class.disabled]="!isFileUpload"
          [style.pointer-events]="!isFileUpload ? 'none' : 'auto'"
          [style.opacity]="!isFileUpload ? '0.5' : '1'"
        >
          <p-button
            label="Place Order"
            (click)="
              ((isPrepaid &&
                (serviceType === 'Both' || serviceType === 'E-Sign')) ||
              (isPrepaid &&
                serviceType === 'E-Stamp' &&
                selectedStampProcessType === 'ON_THE_FLY') ||
              (isPostpaid &&
                (serviceType === 'E-Stamp' || serviceType === 'Both') &&
                selectedStampProcessType === 'ON_THE_FLY'))
                ? calculateOrderPrice()
                : gotoOrderConfirmationPage()
            "
            styleClass="p-button-sm-outline"
          ></p-button>
        </a>
      </div>
    </div>
  </div>
</div>

<!-- Error Modal -->
<p-dialog 
  header="Error Detected" 
  [(visible)]="showErrorModal"
  [modal]="true"
  [style]="{width: '60vw'}"
  [draggable]="false"
  [resizable]="false"
  [closable]="false">
  
  <div class="p-fluid">
    <app-data-table
      [columns]="errorModalColumns"
      [data]="errorModalData?.errors_message_code || []"
      [paginator]="false"
      [scrollable]="(errorModalData?.errors_message_code?.length || 0) > 5"
      scrollHeight="400px">
    </app-data-table>
  </div>

  <ng-template pTemplate="footer">
    <p-button 
      label="Download Excel" 
      icon="pi pi-download"
      (onClick)="downloadErrorExcel()"
      [loading]="excelDownloadLoading">
    </p-button>
    <p-button 
      label="Close" 
      icon="pi pi-times" 
      (onClick)="closeErrorModal()">
    </p-button>
  </ng-template>
</p-dialog>



<ng-template #viewPopUp let-modal>
  <div class="modal-header">
    <h4 class="modal-title">View Bulk Data</h4>
    <app-button
      icon="times"
      [iconOnly]="true"
      [iconOnlyBorderless]="true"
      variant="outline"
      size="sm"
      ariaLabel="Close"
      title="Close"
      (clicked)="modal.dismiss('Cross click')"
    ></app-button>
  </div>
  <div class="modal-body">
    <app-excel-table-editor
      [excelDataList]="convertedData"
      (onSave)="onEditExcelDataseve($event)"
    ></app-excel-table-editor>
  </div>
</ng-template>

<div
  #uploadDocModal
  class="modal fade"
  id="uploadDocModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  data-bs-backdrop="false"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0 pb-2">
        <h5 class="title_five fw-semibold">
          Upload Document <span class="text-danger">*</span>
        </h5>
        <button
          #closeUploadPopupBtn
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          [hidden]="true"
        ></button>
        <button
          type="button"
          class="btn-close"
          (click)="cancelUpload()"
        ></button>
      </div>

      <div class="modal-body px-4 py-2">
        <!-- Drag and Drop Area -->
        <div
          class="upload-area"
          [class.drag-over]="isDragging"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          (click)="fileInput.click()"
        >
          <div class="upload-content">
            <div class="upload-icon mb-2">
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-muted"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17,8 12,3 7,8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
            </div>
            <h6 class="upload-title mb-2">Drop your files here</h6>
            <p class="upload-subtitle mb-2">
              or
              <span
                class="text-primary cursor-pointer text-decoration-underline"
                >click to select file</span
              >
            </p>
            <div class="upload-info">
              <small class="text-muted"
                >Supported format: <b>XLSX, XLS, up to 10 MB</b></small
              >
            </div>
          </div>
        </div>

        <!-- Selected Files Display -->
        <div class="selected-files mt-3" *ngIf="fileName">
          <div
            class="file-item d-flex align-items-center justify-content-between p-2 border rounded"
          >
            <div class="d-flex align-items-center">
              <svg
                width="20"
                height="20"
                class="text-green me-2"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"
                />
              </svg>
              <span class="file-name">{{ fileName }}</span>
            </div>
          </div>
        </div>

        <div>
          <span
            class="p-error"
            style="font-size: 0.65rem; margin-top: 10px"
            *ngIf="chooseFile"
            >Please select document to upload</span
          >
        </div>

        <!-- Hidden File Input -->
        <input
          [hidden]="true"
          type="file"
          id="upload_file"
          (change)="onFileChange($event)"
          accept=".xlsx,.xls"
          #fileInput
          #upload_file
        />

        <!-- Issue Display Section -->
         
        <div
          *ngIf="
            convertedData.length !== 0 &&
            ((issueList.length > 0 && isFileUpload) ||
              branchCodeError.length > 0 ||
              updateByStamp.length > 0 ||
              excelDuplicate.length > 0 ||
              emailDuplicate.length > 0)
          "
          class="mt-3"
        >
          <p class="text-danger mb-2">
            {{
              issueList.length +
                branchCodeError.length +
                updateByStamp.length +
                excelDuplicate.length +
                emailDuplicate.length
            }}
            issue(s) found in the excel data uploaded. Please correct and upload
            again.
          </p>
          <button
            (click)="viewIssues(issueListModal)"
            class="btn btn-danger viewIssues"
          >
            View Issues
          </button>
        </div>
      </div>
<div class="mt-3 px-4" *ngIf="showColumnInput && excelHeaders.length > 0" >
  <label class="form_field">
    Select Columns <span>(Please select the columns that you want to separate by commas.)</span><span class="color_red">*</span>
  </label>
  <small class="text-muted ms-2" style="font-size: 11px;">
    {{ selectedColumns.length }} selected
  </small>
  <div class="mt-2 p-2 border rounded"
       style="max-height: 150px; overflow-y: auto; display: flex; flex-wrap: wrap; gap: 6px;">
    <div *ngFor="let header of excelHeaders"
         class="form-check"
         style="min-width: 180px;">
      <input
        class="form-check-input"
        type="checkbox"
        [id]="'col_' + header"
        (change)="onColumnCheckboxChange($event, header)"
        [checked]="selectedColumns.includes(header)"
      />
      <label class="form-check-label"
             [for]="'col_' + header"
             style="font-size: 12px; cursor: pointer;">
        {{ header }}
      </label>
    </div>
  </div>
</div>
<div
        *ngIf="
         !showColumnInput &&
          convertedData.length !== 0 &&
          issueList.length == 0 &&
          isFileUpload &&
          branchCodeError.length == 0 &&
          updateByStamp.length == 0 &&
          excelDuplicate.length == 0 &&
          emailDuplicate.length == 0
        "
        style="margin-left: 20px; margin-top: 20px"
      >
        <p class="mb-2">No issue(s) found in the excel data uploaded.</p>

        <div class="row">
          <div class="col">
            <div class="r1">
              Total Order:<span class="r1s">{{ total_order }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Total Amount: <span class="r1s">{{ totalStampAmountForPopup }}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="r1">
              Branch Code: <span class="r1s">{{ branchCodeList | json }}</span>
            </div>
          </div>
          <div class="col">
            <div class="r1">
              Requested By: <span class="r1s">{{ userName }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-lg-7 col-sm-7 col-md-7"></div>
        <div class="col-lg-2 col-sm-2 col-md-2">
          <div class="text-right custom_button">
            <p-button
              label="Cancel"
              (click)="cancelUpload()"
              styleClass="p-button-sm"
            >
            </p-button>
          </div>
        </div>
        <div class="col-lg-2 col-sm-2 col-md-2">
          <div class="text-right custom_button">
            <p-button
              label="Upload"
              (click)="uploadSelFile()"
              styleClass="p-button-sm-outline"
              [disabled]="
                this.emailDuplicate.length > 0 ||
                this.excelDuplicate.length > 0 ||
                this.issueList.length > 0 ||
                this.branchCodeError.length > 0 ||
                this.updateByStamp.length > 0
              "
            >
            </p-button>
          </div>
        </div>
      </div>

      <div class="p-2"></div>
    </div>
  </div>
</div>

<div
  #uploadPlaceOrderModal
  class="modal fade"
  id="uploadPlaceOrderModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  data-bs-backdrop="false"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Payment Details Wallet</h5>
        <button
          #closePaymentPopupBtn
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          [hidden]="true"
        ></button>
        <button
          type="button"
          class="btn-close"
          (click)="closePaymentModal()"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body p-4">
        <!-- Bill Details Table -->
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <tbody>
              <tr>
                <td class="fw-bold">Total Order:</td>
                <td class="text-end">{{ total_order }}</td>
              </tr>
              <tr>
                <td class="fw-bold">No. of Stamp:</td>
                <td class="text-end">{{ stampCount }}</td>
              </tr>
              <tr>
                <td class="fw-bold">No. of Aadhaar Sign:</td>
                <td class="text-end">{{ aadhaarCount }}</td>
              </tr>
              <tr>
                <td class="fw-bold">No. of Electronic Sign:</td>
                <td class="text-end">{{ electronicCount }}</td>
              </tr>
              <tr>
                <td class="fw-bold">No. of DSC Sign:</td>
                <td class="text-end">{{ dscCount }}</td>
              </tr>
              <tr>
                <td class="fw-bold">Total Stamp Amount:</td>
                <td class="text-end">{{ totalStampAmount }}</td>
              </tr>
              <tr>
                <td class="fw-bold">Total Convenience Fee:</td>
                <td class="text-end">{{ totalConvFee }}</td>
              </tr>
              <tr>
                <td class="fw-bold">GST:</td>
                <td class="text-end">{{ GSTOnTotalBill }}</td>
              </tr>
              <tr>
                <td class="fw-bold fs-6">Payable Amount:</td>
                <td class="text-end fw-bold fs-6">{{ totalPayableAmount }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!canWalletPayment" class="me-3 ms-3">
          <p style="color: red">Cannot place order due to low wallet Balance</p>
        </div>
      </div>

      <!-- Modal Footer with Buttons -->
      <div class="modal-footer">
        <div class="text-right custom_button">
          <p-button
            [disabled]="!canWalletPayment"
            label="Pay Now"
            (click)="gotoOrderConfirmationPage()"
            styleClass="p-button-sm-outline"
          >
          </p-button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #issueListModal let-modal>
  <div class="modal-header">
    <strong>Issues</strong>
    <button
      style="margin-left: 250px"
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 30rem; overflow: scroll">
    <div class="container">
      <div class="d-flex justify-content-between mb-3">
        <div>
          <span class="title_header">Order Summary</span>
        </div>
        <div></div>
      </div>

      <!-- <div class="row row-cols-2 row-cols-lg-5 g-3 g-lg-4"> -->
      <div class="row">
        <div class="col">
          <div class="r1">
            Total Order:<span class="r1s">{{ total_order }}</span>
          </div>
        </div>
        <div class="col">
          <div class="r1">
            Total Stamp Amount: <span class="r1s">{{ totalStampAmountForPopup }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="r1">
            Branch Code: <span class="r1s">{{ branchCodeList | json }}</span>
          </div>
        </div>
        <div class="col">
          <div class="r1">
            Errors:
            <span class="r1s">{{
              issueList.length +
                branchCodeError.length +
                updateByStamp.length +
                excelDuplicate.length +
                emailDuplicate.length
            }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="r1">
            Requested By: <span class="r1s">{{ userName }}</span>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between mb-3 mt-4">
        <div>
          <span class="title_header">Errors Table</span>
        </div>
        <div></div>
      </div>

      <div class="mt-1" *ngIf="showbulk_estamp">
        <app-data-table
          [columns]="estampErrorColumns"
          [data]="rowsWithIssues"
          [paginator]="false">
        </app-data-table>
      </div>

      <div class="mt-1" *ngIf="showbulk_esign">
        <app-data-table
          [columns]="esignErrorColumns"
          [data]="rowsWithIssues"
          [paginator]="false">
        </app-data-table>
      </div>
      <div>
        <p
          style="color: #2f2f2f; margin-bottom: 5px"
          *ngFor="let item of issueList"
        >
          Row {{ item.rowNumber }}
          :
          {{ item.error }}
        </p>
      </div>
      <div
        *ngIf="updateByStamp.length > 0"
        class="my-3"
        style="max-height: 20rem; overflow-y: scroll; margin: 2px"
      >
        <p
          style="color: #2f2f2f; margin-bottom: 5px"
          *ngFor="let item of updateByStamp"
        >
          Row {{ item.rowNumber }} : {{ item.error }}
        </p>
      </div>
      <div
        *ngIf="excelDuplicate.length > 0"
        class="my-3"
        style="max-height: 20rem; overflow-y: scroll; margin: 2px"
      >
        <p
          style="color: #2f2f2f; margin-bottom: 5px"
          *ngFor="let item of excelDuplicate"
        >
          {{ item.rowNumber }} : {{ item.error }}
        </p>
      </div>
      <div
        *ngIf="emailDuplicate.length > 0"
        class="my-3"
        style="max-height: 20rem; overflow-y: scroll; margin: 2px"
      >
        <p
          style="color: #2f2f2f; margin-bottom: 5px"
          *ngFor="let item of emailDuplicate"
        >
          {{ item.ReferanceId }} : {{ item.error }}
        </p>
      </div>
      <div
        *ngIf="branchCodeError.length > 0"
        class="my-3"
        style="max-height: 20rem; overflow-y: scroll; margin: 2px"
      >
        <p
          style="color: #2f2f2f; margin-bottom: 5px"
          *ngFor="let item of branchCodeError"
        >
          Row {{ item.rowNumber }} : {{ item.error }}
        </p>
      </div>

     <div class="row mt-2">
        <div class="col-lg-4 col-sm-4 col-md-4 offset-8">
          <div class="text-right custom_button" style="display: flex; justify-content: flex-end; gap: 10px;">
            
            <p-button
              label="Download"
              icon="pi pi-download"
              (click)="exportErrorsToExcel()"
              styleClass="p-button-sm"
            >
            </p-button>
            
            <p-button
              label="Okay"
              (click)="modal.dismiss('Cross click')"
              styleClass="p-button-sm-outline"
            >
            </p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<p-toast></p-toast>

<p-confirmDialog
  [style]="{ width: '50vw' }"
  (onAccept)="onApproveMethod()"
></p-confirmDialog>

<ng-template #reviewOrder let-modal>
  <div class="modal-header">
    <strong>Review Order</strong>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeModel()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-content">
    <div class="modal-body">
      <form [formGroup]="reviewDetails">
        <div class="card-body" style="padding: 0">
          <div class="form_outline_sty">
            <div class="form_inputFields col-lg-4 col-sm-4 col-md-4">
              <span class="form_field">Reviewer</span
              ><span class="color_red">*</span>
              <div class="overlay">
                <app-multiselect-dropdown
                  class="custom-dropdown_1 text-left"
                  placeholder="Select Reviewer"
                  [options]="userData"
                  formControlName="reviewer"
                  optionLabel="first_name"
                  (onChange)="selectReviewer()"
                ></app-multiselect-dropdown>
              </div>
              <span
                class="p-error"
                style="font-size: 0.5rem"
                *ngIf="
                  submitted &&
                  reviewDetails.get('reviewer')?.hasError('required')
                "
                >*Select Reviewer
              </span>
            </div>
          </div>
          <div formArrayName="reviewEmail">
            <div class="form_outline_sty">
              <div class="row">
                <section
                  class="col-lg-4 col-sm-12 col-md-6"
                  *ngFor="
                    let details of reviewEmailArray().controls;
                    let detailsIndex = index
                  "
                  [formGroupName]="detailsIndex"
                >
                  <strong class="m-1 mt-2 title_header_0"
                    >Reviewer {{ detailsIndex + 1 }}</strong
                  >
                  <div class="form_inputFields">
                    <div style="display: flex">
                      <input
                        class="form-control"
                        formControlName="email"
                        placeholder="Enter Email"
                        maxlength="50"
                        readonly="true"
                        pInputText
                        type="text"
                      />
                      <span
                        class="p-error"
                        style="font-size: 0.5rem"
                        *ngIf="
                          submitted &&
                          reviewEmailArray()
                            .at(detailsIndex)
                            .get('email')
                            ?.hasError('required')
                        "
                        >*Enter Email</span
                      >
                      <div class="col-lg-1 col-sm-1 col-md-1 remove_btn ps-2">
                        <button
                          pButton
                          pRipple
                          type="button"
                          icon="pi pi-trash"
                          (click)="removeDetails(detailsIndex)"
                          class="p-button-sm"
                        ></button>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="flex_row mt-4 text-right">
        <div>
          <p-button
            label="Back"
            (click)="goBack()"
            styleClass="p-button-sm"
          ></p-button>
        </div>
        <div class="ms-2">
          <p-button
            label="Place Order"
            (click)="placeOrderWithReview()"
            styleClass="p-button-sm-outline"
          >
          </p-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>